/**
 * These, effectively perform the same thing as KnownDocumentActionIds, but are moved out of the
 * instrumentation types package and extended to include 2.0 actions
 */
export var OfficeActionId;
(function (OfficeActionId) {
    OfficeActionId["ConvertToPdf"] = "ConvertToPdf";
    OfficeActionId["ViewPdfExternal"] = "ViewPdfExternal";
    OfficeActionId["NavigateToPdfWorks"] = "NavigateToPdfWorks";
    OfficeActionId["CopyLink"] = "CopyLink";
    OfficeActionId["LocalCopyLink"] = "LocalCopyLink";
    OfficeActionId["CreateTodo"] = "CreateTodo";
    OfficeActionId["Delete"] = "Delete";
    OfficeActionId["DeleteRestore"] = "DeleteRestore";
    OfficeActionId["Edit"] = "Edit";
    OfficeActionId["Favorite"] = "Favorite";
    OfficeActionId["Hide"] = "Hide";
    OfficeActionId["ViewTodoExternal"] = "ViewTodoExternal";
    OfficeActionId["Download"] = "Download";
    OfficeActionId["Open"] = "Open";
    OfficeActionId["OpenInApp"] = "OpenInNative";
    OfficeActionId["OpenInBrowser"] = "OpenInBrowser";
    OfficeActionId["OpenFileLocation"] = "OpenFileLocation";
    OfficeActionId["RemoveFromRecommended"] = "RemoveFromRecommended";
    OfficeActionId["Schedule"] = "Schedule";
    OfficeActionId["Share"] = "Share";
    OfficeActionId["ShareToTeams"] = "ShareToTeams";
    OfficeActionId["Tag"] = "Tag";
    OfficeActionId["Unfavorite"] = "Unfavorite";
    OfficeActionId["Unhide"] = "Unhide";
})(OfficeActionId || (OfficeActionId = {}));
export var DefaultOfficeAppId = 'office_app_id';
//# sourceMappingURL=officeActionId.js.map